import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

import check from './modules/check'
import company from './modules/company'
import study from './modules/study'
import faq from './modules/faq'
import stopword from './modules/stopword'
import xenu from './modules/xenu'
import pay from './modules/pay'
import task from './modules/task'
import exam from './modules/exam'
import qiniu from './modules/qiniu'
import message from './modules/message'
import ad from './modules/ad'
import group from './modules/company.group'
import dynamic from './modules/dynamic'
import include from './modules/include'
import keywords from './modules/keywords'
import vip from './modules/vip'
import stopwordLog from './modules/stopwordLog'
import myorder from './modules/myorder'
import welfare from './modules/welfare'
import wordDensity from './modules/wordDensity'
import external from './modules/external'
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        check,
        company,
        study,
        faq,
        stopword,
        xenu,
        pay,
        task,
        exam,
        qiniu,
        message,
        ad,
        group,
        dynamic,
        include,
        keywords,
        vip,
        stopwordLog,
        myorder,
        welfare,
        wordDensity,
        external
    },
    state,
    getters,
    mutations,
    actions
})



// WEBPACK FOOTER //
// ./app/store/index.js